import { StoreJoyride } from '../../Types/StoreTypes';

export const SET_RUN = 'SET_RUN';
export const SET_STEP_INDEX = 'SET_STEP_INDEX';
export const SET_START_TOUR = 'SET_START_TOUR';

export function setRun(run: StoreJoyride['run']) {
    return { type: SET_RUN, payload: run };
}

export function setStepIndex(stepIndex: StoreJoyride['stepIndex']) {
    return { type: SET_STEP_INDEX, payload: stepIndex };
}

export function setStartTour(startTour: StoreJoyride['startTour']) {
    return { type: SET_START_TOUR, payload: startTour };
}
